import React, { useState, useEffect, Fragment } from "react";
import styles from "./PartnerData.module.sass";
import form from "../UserForm.module.sass";

import TitleSection from "../../TitleSection/TitleSection";
import theme from "../../../App.module.sass";
import masks from "../../../utils/masks";
import Input from "../../ui/Input/Input";
import Button from "../../ui/Button/Button";
import Table from "react-bootstrap/Table";
import validation from "../../../utils/validation";

import ExposedPerson from "../ExposedPerson/ExposedPerson";
import RadioGroup from "../../ui/RadioGroup/RadioGroup";

const validate = (setPartners, partners, newPartner, setNewPartner) => {
  const formElement = document.getElementById("newPartner");
  const inputs = Array.from(formElement.getElementsByTagName("input")).filter(
    (input) => !input.readOnly
  );

  let validForm = true;
  let divToFocus;

  for (const input of inputs) {
    input.focus();
    input.blur();
    if (input.getAttribute("valid") === "false") {
      validForm = false;
      divToFocus = divToFocus || input;
    }
  }

  const innerValidate = () => {
    for (const input of inputs) {
      if (input.getAttribute("valid") === "false") {
        validForm = false;
        divToFocus = divToFocus || input;
      }
    }

    if (validForm) {
      setPartners([...partners, newPartner]);
      setNewPartner(null);
    } else {
      divToFocus.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  setTimeout(innerValidate, 0);
};

const partnerData = (props) => {
  const [partners, setPartners] = useState([]);
  const [exposed, setExposed] = useState("N");
  const [newPartner, setNewPartner] = useState({
    name: "",
    cpf: "",
    birthDate: "",
    gender: "F",
    participation: "",
  });

  const onChange = (value, name) => {
    setNewPartner({ ...newPartner, [name]: value });
  };

  useEffect(() => {
    props.onChange(partners, exposed, newPartner);
  }, [partners, exposed, newPartner]);

  const cotista = props.data.origem.cotista;

  const addPartnerHandler = () => {
    if (newPartner) {
      validate(setPartners, partners, newPartner, setNewPartner);
    } else {
      setNewPartner({
        name: "",
        cpf: "",
        birthDate: "",
        gender: "F",
        participation: "",
      });
    }
  };

  const partnerDataHandler = (cpf) => {
    setNewPartner({
      ...newPartner,
      cpf: cpf,
    });
  };

  function removePartner(index) {
    const updatedPartners = [...partners];
    updatedPartners.splice(index, 1);
    setPartners(updatedPartners);
    if (updatedPartners.length === 0) {
      setNewPartner({
        name: "",
        cpf: "",
        birthDate: "",
        gender: "F",
        participation: "",
      });
    }
  }

  return (
    <Fragment>
      <section className={[form.sectionForm, styles.sectionPartner].join(" ")}>
        <div className={styles.contentPartner}>
          {(partners.length > 0 || newPartner) && (
            <TitleSection title="Dados do Sócio" />
          )}

          {partners.length > 0 ? (
            <div className={styles.partnerTable}>
              <Table responsive>
                <thead>
                  <tr>
                    <th className={styles.nameColumn}>Nome</th>
                    <th>CPF</th>
                    <th>Data de Nascimento</th>
                    <th>Sexo</th>
                    <th className={styles.participationColumn}>Participação</th>
                    <th>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {partners.map((partner, index) => {
                    return (
                      <tr key={index}>
                        <td>{partner.name}</td>
                        <td>{masks.cpf(partner.cpf)}</td>
                        <td>{masks.date(partner.birthDate)}</td>
                        <td>{partner.gender}</td>
                        <td className={styles.participationValue}>
                          {partner.participation} %
                        </td>
                        <td>
                          <i
                            onClick={() => removePartner(index)}
                            className={"icon icon-apagar"}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          ) : null}
          {newPartner ? (
            <div className={styles.newPartner} id="newPartner">
              <div className={theme.row} id="partnerForm">
                <Input
                  className={theme.col40}
                  name="cpf"
                  value={newPartner.cpf}
                  onChange={partnerDataHandler}
                  type="text"
                  typeDocument="CPF"
                  mask={masks.cpf}
                  validationRules={[validation.required, validation.vCpf]}
                  maxLength={14}
                />
              </div>

              <div className={theme.row}>
                <Input
                  className={theme.col}
                  name="name"
                  value={newPartner.name}
                  onChange={onChange}
                  type="text"
                  typeDocument="Nome"
                  readonly={newPartner.cotista}
                  maxLength={79}
                  validationRules={[
                    validation.required,
                    validation.minLength(3),
                    validation.lettersOnly,
                  ]}
                />
              </div>
              <div className={theme.row}>
                <Input
                  className={theme.col30}
                  name="participation"
                  value={newPartner.participation}
                  onChange={onChange}
                  type="text"
                  typeDocument="Percentual de participação"
                  maxLength={18}
                  validationRules={[
                    validation.required,
                    validation.numbersOnly,
                    validation.maxPercentageValue(100),
                  ]}
                />
                <Input
                  className={theme.col30}
                  name="birthDate"
                  value={newPartner.birthDate}
                  onChange={onChange}
                  type="text"
                  mask={masks.date}
                  typeDocument="Data de nascimento"
                  readonly={newPartner.cotista}
                  validationRules={[validation.required, validation.date]}
                />
                <div className={[theme.radioOptions, theme.col30].join(" ")}>
                  <label className={styles.formLabel}>Sexo:</label>
                  <RadioGroup
                    options={["Feminino", "Masculino"].map((el) => ({
                      value: el === "Feminino" ? "F" : "M",
                      text: el,
                    }))}
                    value={newPartner.gender}
                    onChanged={(value) => {
                      setNewPartner({ ...newPartner, gender: value });
                    }}
                  />
                </div>
              </div>
            </div>
          ) : null}
        </div>
        <Button type="button" onClick={addPartnerHandler}>
          Adicionar sócio
        </Button>
      </section>
      <section className={form.sectionForm}>
        <ExposedPerson
          onChange={(value) => {
            setExposed(value);
          }}
          readonly={cotista}
          pj
        />
      </section>
    </Fragment>
  );
};

export default partnerData;
